import querySerializer from 'query-string';
import restoreScroll from 'redux-first-router-restore-scroll';
import { NOT_FOUND, redirect } from 'redux-first-router';

export default {
	querySerializer,
	restoreScroll: restoreScroll({
		shouldUpdateScroll: () => false,
	}),
	onBeforeChange: (dispatch, getState, bag) => {
		// Control that we have language, else add language.
		// Add hash as a payload parameter.
		if (!getState().environment.setup.languages) return true;
		const languages = Object.keys(getState().environment.setup.languages);
		const { payload, meta } = bag.action;
		let { type } = bag.action;
		let { language = '', path = '', search = '', hash = '' } = payload;
		if (Object.keys(payload).length === 0) return true;
		let update = false;

		if (!language) {
			language = getState().environment.setup.language;
			update = true;
		}

		if (languages.indexOf(language) === -1) {
			path = path ? `${language}/${path}` : `${language}`; // "language" is really a path.
			language = getState().environment.setup.language;
			type = 'CATEGORY_PRODUCT_PAGE';
			update = true;
		}

		search = search || meta.query || '';

		if (path.indexOf('#') !== -1 && hash === '') {
			hash = path.slice(path.indexOf('#'));
			path = path.slice(0, path.indexOf('#'));
			update = true;
		}

		if (update && type !== NOT_FOUND) {
			return dispatch(redirect({ type, payload: { language, path, search, hash } }));
		}

		return true;
	},
};
